var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "main" } },
    [
      _c("h1", { attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.$t("Registration.RegisterAdminUser.Title")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("Registration.RegisterAdminUser.Description1")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("Registration.RegisterAdminUser.Description2")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            {
              class: [!_vm.authenticated ? "active" : "", "registration-step"],
              attrs: { "aria-current": !_vm.authenticated ? "step" : false }
            },
            [
              _vm._v(
                "\n        1. " +
                  _vm._s(_vm.$t("Registration.RegisterAdminUser.Step1")) +
                  "\n        "
              ),
              _vm.authenticated
                ? _c("i", { staticClass: "fas fa-check icon green fa-lg" }, [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t("Registration.Phase.Done")))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.authenticated
                ? _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Registration.Phase.Active")))
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            {
              class: [
                _vm.authenticated && !_vm.readyToSubmit ? "active" : "",
                "registration-step"
              ],
              attrs: {
                "aria-current":
                  _vm.authenticated && !_vm.readyToSubmit ? "step" : false
              }
            },
            [
              _vm._v(
                "\n        2. " +
                  _vm._s(_vm.$t("Registration.RegisterAdminUser.Step2")) +
                  "\n        "
              ),
              _vm.authenticated && _vm.readyToSubmit
                ? _c("i", { staticClass: "fas fa-check icon green fa-lg" }, [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t("Registration.Phase.Done")))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.authenticated && !_vm.readyToSubmit
                ? _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Registration.Phase.Active")))
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            {
              class: [
                _vm.authenticated && _vm.readyToSubmit ? "active" : "",
                "registration-step"
              ],
              attrs: {
                "aria-current":
                  _vm.authenticated && _vm.readyToSubmit ? "step" : false
              }
            },
            [
              _vm._v(
                "\n        3. " +
                  _vm._s(_vm.$t("Registration.RegisterAdminUser.Step3")) +
                  "\n        "
              ),
              _vm.authenticated && _vm.readyToSubmit
                ? _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Registration.Phase.Active")))
                  ])
                : _vm._e()
            ]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.authenticated ? _c("suomi-fi-authentication") : _vm._e(),
      _vm._v(" "),
      _vm.authenticated && !_vm.readyToSubmit
        ? _c("admin-user-info", {
            attrs: { suomiFiResponse: _vm.suomiFiResponse },
            on: {
              saved: function($event) {
                return _vm.saved($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated && _vm.readyToSubmit
        ? _c("admin-confirmation", {
            attrs: { registration: _vm.registration }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }